/* Tersa clone — buy box, gallery, sticky bar, slide-in cart, cross-sells, free gift, bundle */
(function(){
  if(window.__tersaCloneInit) return; window.__tersaCloneInit = true;

  var GLOVE_HANDLE = 'exfoliating-glove-for-bath-scrubbing';
  var BUNDLE = { code:'RUTINA', label:'Rutina completa', vids:['52770145140917','52976801644725','52979952681141','52797001957557'] };
  var CATALOG = [
    { handle:'tersa-crema-multiacida', vid:'52770145140917', name:'Crema corporal multiácida', blurb:'El paso 1 para la piel de gallina', url:'/products/tersa-crema-multiacida', price:null, img:'', loaded:false },
    { handle:'turmeric-kojic-acid-soap', vid:'52976801644725', name:'Jabón de cúrcuma y ácido kójico', blurb:'Empareja el tono · hiperpigmentación', url:'/products/turmeric-kojic-acid-soap', price:null, img:'', loaded:false },
    { handle:'exfoliating-glove-for-bath-scrubbing', vid:'52979952681141', name:'Guante exfoliante suave', blurb:'Maximiza resultados al remover células muertas', url:'/products/exfoliating-glove-for-bath-scrubbing', price:null, img:'', loaded:false },
    { handle:'ebook-piel-mas-suave-guia-kp', vid:'52797001957557', name:'E-book (PDF)', blurb:'Guía de la piel de gallina', url:'/products/ebook-piel-mas-suave-guia-kp', price:null, img:'', loaded:false, hideXsell:true }
  ];

  function money(cents, cur){
    try { return new Intl.NumberFormat(undefined, { style:'currency', currency: cur || 'USD' }).format((cents||0)/100); }
    catch(e){ return '$' + ((cents||0)/100).toFixed(2); }
  }
  function loadItem(it){
    if(it.loaded) return Promise.resolve();
    return fetch('/products/' + it.handle + '.js', { headers:{ 'Accept':'application/json' } }).then(function(r){ return r.json(); }).then(function(p){
      var v = null; (p.variants||[]).forEach(function(x){ if(String(x.id)===String(it.vid)) v = x; });
      if(!v && p.variants && p.variants.length) v = p.variants[0];
      if(v){ it.vid = v.id; it.price = v.price; }
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if(img && img.indexOf('//')===0) img = 'https:' + img;
      it.img = img; it.loaded = true;
    }).catch(function(){});
  }
  function loadCatalog(){ return Promise.all(CATALOG.map(loadItem)); }

  function ensureStyles(){
    if(document.getElementById('tersa-cart-css')) return;
    var s = document.createElement('style'); s.id = 'tersa-cart-css';
    s.textContent = ".tersa-cart-overlay{position:fixed;inset:0;background:rgba(46,38,33,.45);opacity:0;visibility:hidden;transition:opacity .25s;z-index:99999;display:flex;justify-content:flex-end;}"+
".tersa-cart-overlay.is-open{opacity:1;visibility:visible;}"+
".tersa-cart{width:min(410px,93vw);height:100%;background:#F5EDE2;transform:translateX(100%);transition:transform .28s cubic-bezier(.4,0,.2,1);display:flex;flex-direction:column;box-shadow:-8px 0 30px rgba(46,38,33,.18);font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;}"+
".tersa-cart-overlay.is-open .tersa-cart{transform:translateX(0);}"+
".tersa-cart-head{display:flex;align-items:center;justify-content:space-between;padding:20px 22px;border-bottom:1px solid rgba(46,38,33,.1);font-size:19px;font-weight:700;color:#2E2621;}"+
".tersa-cart-x{background:none;border:none;font-size:26px;line-height:1;cursor:pointer;color:#7C3350;}"+
".tersa-cart-body{padding:20px 22px;overflow-y:auto;flex:1;display:flex;flex-direction:column;}"+
".tersa-cart-line{display:flex;align-items:center;gap:12px;padding-bottom:14px;border-bottom:1px solid rgba(46,38,33,.1);margin-bottom:14px;}"+
".tersa-cart-line img{width:56px;height:56px;object-fit:cover;border-radius:10px;background:#F0C3A6;}"+
".tersa-cart-line-t{flex:1;display:flex;flex-direction:column;gap:2px;}"+
".tersa-cart-line-t strong{font-size:13.5px;color:#2E2621;line-height:1.25;}"+
".tersa-cart-line-t span{font-size:12px;color:#6a3a24;}"+
".tersa-cart-line-p{font-size:13.5px;font-weight:700;color:#2E2621;white-space:nowrap;text-align:right;}"+
".tersa-up-h{font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#7C3350;margin:2px 0 8px;}"+
".tersa-cart-up{border:1px solid rgba(46,38,33,.14);border-radius:14px;padding:11px;display:flex;gap:11px;align-items:center;margin-bottom:10px;background:#fff;}"+
".tersa-cart-up.bundle{background:#F0C3A6;border-color:#C86F4C;}"+
".tersa-cart-up img{width:50px;height:50px;object-fit:cover;border-radius:9px;background:#F0C3A6;display:block;}"+
".tersa-cart-up-t{flex:1;min-width:0;}"+
".tersa-cart-up-t strong{display:block;font-size:12.5px;color:#2E2621;line-height:1.2;}"+
".tersa-cart-up-t .bl{display:block;font-size:11px;color:#6a3a24;margin:2px 0;}"+
".tersa-cart-up-t b{font-size:12.5px;color:#7C3350;}"+
".tersa-cart-up-t s{font-size:11px;color:#9a7a68;margin-left:4px;}"+
".tersa-cart-up-t a{color:#7C3350;}"+
".tersa-cart-up button{border:none;background:#C86F4C;color:#fff;font-weight:700;font-size:12.5px;padding:9px 13px;border-radius:9px;cursor:pointer;white-space:nowrap;}"+
".tersa-cart-up button:disabled{opacity:.6;cursor:default;}"+
".tersa-cart-totals{display:flex;flex-direction:column;gap:8px;margin:8px 0 16px;}"+
".tersa-cart-row{display:flex;justify-content:space-between;font-size:14px;color:#4a3f37;}"+
".tersa-cart-save{color:#7C3350;font-weight:600;}"+
".tersa-cart-total{font-size:18px;font-weight:800;color:#2E2621;padding-top:8px;border-top:1px solid rgba(46,38,33,.12);}"+
".tersa-cart-note{font-size:12px;color:#7C3350;margin:0 0 14px;}"+
".tersa-cart-go{display:block;text-align:center;text-decoration:none;padding:16px;border-radius:12px;background:#7C3350;color:#F5EDE2;font-weight:700;font-size:16px;margin-top:auto;}"+
".tersa-cart-cont{background:none;border:none;margin-top:12px;padding:8px;color:#6a3a24;text-decoration:underline;cursor:pointer;font-size:13.5px;}";
    document.head.appendChild(s);
  }

  function init(){
    var root = document.querySelector('[data-tersa-app]');
    var opts = root ? Array.prototype.slice.call(root.querySelectorAll('[data-tersa-opt]')) : [];
    var atcTotals = document.querySelectorAll('[data-tersa-atc-total]');
    var barTotal = document.querySelector('[data-tersa-bar-total]');
    var barMode = document.querySelector('[data-tersa-bar-mode]');
    var ebook = root ? root.querySelector('[data-tersa-ebook]') : null;
    var CREAM_VID = (root && root.getAttribute('data-cream-vid')) || (opts[0] ? opts[0].getAttribute('data-variant-id') : '52770145140917');
    var jsonHeaders = { 'Content-Type':'application/json' };

    var state = { variantId:null, qty:1, code:'', total:'', label:'', giftVid:'' };
    function select(opt){
      opts.forEach(function(o){ var on = o===opt; o.classList.toggle('is-selected', on); o.setAttribute('aria-checked', on?'true':'false'); });
      state.variantId = opt.getAttribute('data-variant-id');
      state.qty = parseInt(opt.getAttribute('data-qty')||'1',10);
      state.code = opt.getAttribute('data-code')||'';
      state.total = opt.getAttribute('data-total');
      state.label = opt.getAttribute('data-mode-label')||'';
      state.giftVid = opt.getAttribute('data-gift-vid')||'';
      var showEbook = opt.getAttribute('data-ebook')==='1';
      atcTotals.forEach(function(el){ el.textContent = state.total; });
      if(barTotal) barTotal.textContent = state.total;
      if(barMode) barMode.textContent = state.label;
      if(ebook) ebook.classList.toggle('is-on', showEbook);
    }
    opts.forEach(function(o){
      o.addEventListener('click', function(){ select(o); });
      o.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); select(o); } });
    });
    var def = opts[0] || (root && root.querySelector('[data-tersa-opt][data-default]'));
    if(def) select(def);

    if(root){
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tersa-thumb]'));
      var mainImg = root.querySelector('[data-tersa-main]');
      var mainLabel = root.querySelector('[data-tersa-main-label]');
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          thumbs.forEach(function(x){ x.classList.toggle('is-active', x===t); });
          var src = t.getAttribute('data-img');
          if(mainImg){
            if(src){ mainImg.style.backgroundImage = "url('"+src+"')"; mainImg.style.backgroundSize='cover'; mainImg.style.backgroundPosition='center'; }
            if(mainLabel) mainLabel.textContent = t.getAttribute('data-label')||'';
          }
        });
      });
    }

    var overlay, panel, bodyEl;
    function buildDrawer(){
      if(overlay) return;
      ensureStyles();
      overlay = document.createElement('div'); overlay.className = 'tersa-cart-overlay';
      panel = document.createElement('aside'); panel.className = 'tersa-cart'; panel.setAttribute('role','dialog'); panel.setAttribute('aria-label','Carrito');
      panel.innerHTML = '<div class="tersa-cart-head"><span>Tu carrito</span><button type="button" class="tersa-cart-x" aria-label="Cerrar">×</button></div><div class="tersa-cart-body" data-tersa-cart-body></div>';
      overlay.appendChild(panel); document.body.appendChild(overlay);
      bodyEl = panel.querySelector('[data-tersa-cart-body]');
      overlay.addEventListener('click', function(e){ if(e.target===overlay) closeDrawer(); });
      panel.querySelector('.tersa-cart-x').addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });
    }
    function openDrawer(){ buildDrawer(); requestAnimationFrame(function(){ overlay.classList.add('is-open'); }); }
    function closeDrawer(){ if(overlay) overlay.classList.remove('is-open'); }

    function orig(it){ return (it.original_line_price != null ? it.original_line_price : (it.line_price||0)); }

    function renderDrawer(cart){
      var cur = (cart && cart.currency) || 'USD';
      var items = (cart && cart.items) || [];
      var isBundle = (state.code === BUNDLE.code);
      var creamBase = 0, creamQty = 0, subtotal = 0, gloveLine = null, cartHandles = {};
      items.forEach(function(it){
        subtotal += orig(it);
        if(it.handle) cartHandles[it.handle] = true;
        if(String(it.variant_id) === String(CREAM_VID)){ creamBase += orig(it); creamQty += it.quantity; }
        if(it.handle === GLOVE_HANDLE) gloveLine = it;
      });
      var giftActive = !isBundle && creamQty >= 3 && gloveLine;
      var giftDisc = giftActive ? orig(gloveLine) : 0;
      var unit = creamQty > 0 ? Math.round(creamBase / creamQty) : 0;
      var creamDisc = isBundle ? 0 : (creamQty === 2 ? (unit - Math.round(unit * 0.5)) : (creamQty >= 3 ? unit : 0));
      var total, bundleDisc = 0;
      if(isBundle){ total = (cart && cart.total_price != null) ? cart.total_price : subtotal; bundleDisc = subtotal - total; }
      else { total = subtotal - creamDisc - giftDisc; }

      var lines = '';
      items.forEach(function(it){
        var isGift = giftActive && it.handle === GLOVE_HANDLE;
        var isCream = String(it.variant_id) === String(CREAM_VID);
        var img = it.image ? it.image : '';
        var sub = isCream ? (state.label||'') : (isGift ? 'Regalo' : (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : ''));
        var priceHtml = isGift ? ('<span style="text-decoration:line-through;opacity:.5;font-weight:500;">'+ money(orig(it), cur) +'</span> <b style="color:#7C3350;">GRATIS</b>') : money(orig(it), cur);
        lines += '<div class="tersa-cart-line">' + (img?('<img src="'+img+'" alt="">'):'') + '<div class="tersa-cart-line-t"><strong>'+ (it.product_title||'') +'</strong>' + (sub?('<span>'+sub+'</span>'):'') + '<span>Cantidad: '+ it.quantity +'</span></div><span class="tersa-cart-line-p">'+ priceHtml +'</span></div>';
      });

      var upsell = '';
      var bundleInCart = BUNDLE.vids.every(function(v){ var found=false; items.forEach(function(it){ if(String(it.variant_id)===String(v)) found=true; }); return found; });
      var bundleValue = 0, bundleReady = true;
      CATALOG.forEach(function(c){ if(c.price!=null) bundleValue += c.price; else bundleReady = false; });
      var xs = CATALOG.filter(function(c){ return !c.hideXsell && !cartHandles[c.handle] && c.loaded && c.price != null; }).slice(0, 2);
      if((!bundleInCart && bundleReady) || xs.length){
        upsell = '<div class="tersa-up-h">Completa tu rutina</div>';
        if(!bundleInCart && bundleReady){
          var bDiscApprox = Math.round(bundleValue * 0.1789);
          var bPrice = bundleValue - bDiscApprox;
          upsell += '<div class="tersa-cart-up bundle"><div class="tersa-cart-up-t"><strong>Rutina completa</strong><span class="bl">Crema + jabón + guante + e-book</span><b>'+ money(bPrice, cur) +'</b><s>'+ money(bundleValue, cur) +'</s></div><button type="button" data-add-bundle>Agregar</button></div>';
        }
        xs.forEach(function(c){
          upsell += '<div class="tersa-cart-up">' + (c.img?('<a href="'+c.url+'"><img src="'+c.img+'" alt=""></a>'):'') + '<div class="tersa-cart-up-t"><strong><a href="'+c.url+'" style="color:inherit;text-decoration:none;">'+ c.name +'</a></strong><span class="bl">'+ c.blurb +'</span><b>'+ money(c.price, cur) +'</b> · <a href="'+c.url+'" style="font-size:11px;">Ver más</a></div><button type="button" data-add-vid="'+ c.vid +'">Añadir</button></div>';
        });
      }

      var checkoutHref = state.code ? ('/discount/' + encodeURIComponent(state.code) + '?redirect=%2Fcheckout') : '/checkout';
      var totals = '<div class="tersa-cart-totals"><div class="tersa-cart-row"><span>Subtotal</span><span>'+ money(subtotal, cur) +'</span></div>';
      if(isBundle){ if(bundleDisc > 0) totals += '<div class="tersa-cart-row tersa-cart-save"><span>Descuento · rutina completa</span><span>−'+ money(bundleDisc, cur) +'</span></div>'; }
      else { if(creamDisc > 0) totals += '<div class="tersa-cart-row tersa-cart-save"><span>Descuento · '+ (state.label||'oferta') +'</span><span>−'+ money(creamDisc, cur) +'</span></div>'; if(giftDisc > 0) totals += '<div class="tersa-cart-row tersa-cart-save"><span>Regalo · guante</span><span>−'+ money(giftDisc, cur) +'</span></div>'; }
      totals += '<div class="tersa-cart-row tersa-cart-total"><span>Total</span><span>'+ money(total, cur) +'</span></div></div>';

      var html = lines + upsell + totals;
      if(state.code){ html += '<p class="tersa-cart-note">Los descuentos se aplican al pasar al pago.</p>'; }
      html += '<a class="tersa-cart-go" href="'+ checkoutHref +'">Ir al pago — '+ money(total, cur) +'</a>';
      html += '<button type="button" class="tersa-cart-cont" data-tersa-cart-cont>Seguir viendo</button>';
      bodyEl.innerHTML = html;

      var cont = bodyEl.querySelector('[data-tersa-cart-cont]');
      if(cont) cont.addEventListener('click', closeDrawer);
      var bb = bodyEl.querySelector('[data-add-bundle]');
      if(bb) bb.addEventListener('click', function(){ addBundle(bb); });
      Array.prototype.slice.call(bodyEl.querySelectorAll('[data-add-vid]')).forEach(function(b){ b.addEventListener('click', function(){ addUpsell(b, b.getAttribute('data-add-vid')); }); });
    }

    function getCart(){ return fetch('/cart.js', { headers: { 'Accept':'application/json' } }).then(function(r){ return r.json(); }); }

    function addUpsell(btn, vid){
      if(!vid || btn.disabled) return;
      btn.disabled = true; btn.textContent = 'Agregando…';
      fetch('/cart/add.js', { method:'POST', headers: jsonHeaders, body: JSON.stringify({ items:[{ id: vid, quantity: 1 }] }) })
        .then(getCart).then(function(cart){ renderDrawer(cart || {}); })
        .catch(function(){ btn.disabled = false; btn.textContent = 'Añadir'; });
    }

    var busy = false;
    function addBundle(btn){
      if(busy) return; busy = true;
      var prev = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = 'Agregando…'; }
      var done = function(){ if(btn){ btn.disabled = false; btn.textContent = prev; } busy = false; };
      state.code = BUNDLE.code; state.label = BUNDLE.label; state.variantId = BUNDLE.vids[0]; state.qty = 1; state.giftVid = '';
      var lineItems = BUNDLE.vids.map(function(v){ return { id: v, quantity: 1 }; });
      fetch('/cart/clear.js', { method:'POST', headers: jsonHeaders })
        .then(function(){ return fetch('/cart/add.js', { method:'POST', headers: jsonHeaders, body: JSON.stringify({ items: lineItems }) }); })
        .then(function(){ return fetch('/discount/' + encodeURIComponent(BUNDLE.code) + '?redirect=%2Fcart.js', { headers: { 'Accept':'application/json' } }).then(function(r){ return r.json(); }).catch(getCart); })
        .then(function(cart){ return loadCatalog().then(function(){ return cart; }); })
        .then(function(cart){ buildDrawer(); renderDrawer(cart || {}); openDrawer(); done(); })
        .catch(function(){ done(); window.location.href = '/cart'; });
    }
    document.querySelectorAll('[data-tersa-bundle]').forEach(function(btn){ btn.addEventListener('click', function(e){ e.preventDefault(); addBundle(btn); }); });

    function addToCart(btn){
      if(!state.variantId || busy) return; busy = true;
      var labelEl = btn.querySelector('[data-tersa-atc-label]');
      var prev = labelEl ? labelEl.textContent : '';
      if(labelEl) labelEl.textContent = 'Agregando…';
      var reset = function(){ if(labelEl) labelEl.textContent = prev || 'Agregar al carrito'; busy = false; };
      fetch('/cart/clear.js', { method:'POST', headers: jsonHeaders })
        .then(function(){ return fetch('/cart/add.js', { method:'POST', headers: jsonHeaders, body: JSON.stringify({ items: [{ id: state.variantId, quantity: state.qty }] }) }); })
        .then(function(){ if(state.giftVid){ return fetch('/cart/add.js', { method:'POST', headers: jsonHeaders, body: JSON.stringify({ items: [{ id: state.giftVid, quantity: 1 }] }) }); } })
        .then(function(){
          if(state.code){
            return fetch('/discount/' + encodeURIComponent(state.code) + '?redirect=%2Fcart.js', { headers: { 'Accept':'application/json' } }).then(function(r){ return r.json(); }).catch(getCart);
          }
          return getCart();
        })
        .then(function(cart){ return loadCatalog().then(function(){ return cart; }); })
        .then(function(cart){ buildDrawer(); renderDrawer(cart || {}); openDrawer(); reset(); })
        .catch(function(){ reset(); var url = '/cart/' + state.variantId + ':' + state.qty; if(state.code) url += '?discount=' + encodeURIComponent(state.code); window.location.href = url; });
    }
    document.querySelectorAll('[data-tersa-atc]').forEach(function(btn){ btn.addEventListener('click', function(e){ e.preventDefault(); addToCart(btn); }); });

    var sticky = document.querySelector('[data-tersa-sticky]');
    if(sticky && root){
      var heroAtc = root.querySelector('[data-tersa-atc]');
      if(sticky.parentNode !== document.body){ document.body.appendChild(sticky); }
      var show = function(v){ sticky.classList.toggle('is-visible', v); };
      if(heroAtc && 'IntersectionObserver' in window){
        new IntersectionObserver(function(entries){ show(!entries[0].isIntersecting); }, { threshold: 0 }).observe(heroAtc);
      } else {
        var onScroll = function(){ show((window.scrollY || document.documentElement.scrollTop || 0) > 640); };
        window.addEventListener('scroll', onScroll, { passive:true });
        onScroll();
      }
    }
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
